import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { selectUpcomingDueDate } from "app/modules/schools/selectors";

export default function useHideExportButton() {
  const upcomingDueDate = useSelector(selectUpcomingDueDate);
  const daysRemaining = dayjs(upcomingDueDate).diff(dayjs(), "day");
  return daysRemaining < 0;
}
